import React, { useEffect, useState } from 'react'
import './IdCard.css'

import contactDataTr from '../data/jsons/contact.tr.json'
import contactDataEn from '../data/jsons/contact.en.json'

import IdContactPropt from './IdContactPropt'
import IdPhoto from '../data/avatar.JPG'
import MailIcon from '../data/icons/Mail.svg'
import GithubIcon from '../data/icons/Github.svg'
import LinkedinIcon from '../data/icons/Linkedin.svg'
import ImstagramIcon from '../data/icons/Instagram.svg'

const iconMap = {
    "Mail": MailIcon,
    "Linkedin": LinkedinIcon,
    "Github": GithubIcon,
    "Instagram": ImstagramIcon
};

function IdCard() {
    const [isEnglish, setIsEnglish] = useState(
        localStorage.getItem('pageLanguage') === 'true'
    );

    useEffect(() => {
        const handleLangChange = () => {
            setIsEnglish(localStorage.getItem('pageLanguage') === 'true');
        };
        window.addEventListener("languageChange", handleLangChange);
        return () => {
            window.removeEventListener("languageChange", handleLangChange);
        };
    }, []);

    const contactData = isEnglish ? contactDataEn : contactDataTr;

    function ContactButtonFunc(){
        var ActivePage = document.getElementsByClassName("Active");
        Array.from(ActivePage).forEach(item => {
            item.classList.remove("Active");
        })
        var ContactPage = document.getElementsByClassName("Contact");
        Array.from(ContactPage).forEach(item => {
            item.classList.add("Active");
        })
    }

    return (
        <div id='Id-Container'>
            <div id='Id-Top'>
                <img src={IdPhoto} alt='Id-Photo' id='Id-Photo'/>
                <div id='Id-Name-Section'>
                    <p id='Id-Name' translate='no'>Tuna Muş</p> 
                    <button className='Id-Contact-Button' onClick={ContactButtonFunc}>{contactData.header.title}</button>
                </div>
            </div>
            <hr id='Id-Line'/>
            <div id='Id-Contact'>
                {contactData.contact.map((item) => (
                    <IdContactPropt Header={item.title} Text={item.data} IsLink={true} Link={item.url} Photo={iconMap[item.icon]}/>
                ))}
            </div>
        </div>
    )
    }

export default IdCard